import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import RegisterForm from "./Register/RegisterForm";
import LoginForm from "./Login/LoginForm";
import EnterAmazonUrl from "./AmazonUrl/EnterAmazonUrl";
import { Confirmation } from "./Confirmation";
import AppApprovalForm from "./AppApproval/AppApproval";
import AffiliateRegisterForm from "./AffiliateRegisterForm/‎AffiliateRegisterForm";
import AffiliateLayout from "./Layout/AffiliateLayout";
import LoginAffiliateForm from "./Login/LoginAffiliateForm";
import AffiliateMonthlyBreakdown from "./AffiliateMonthlyBreakdown/AffiliateMonthlyBreakdown";
import Layout from "./Layout/Layout";
import PartnerOnboardingBridge from "./Partner/PartnerOnboardingBridge";
import { SessionSorageInstance } from "../Services/SessionStorageService";
import ExternalAwsAuthResult from "./AppApproval/ExternalAwsAuthResult";

export const Routing = () => {

  const ProtectedRoute = ({ children, ...rest }) => {
    let auth = SessionSorageInstance.getToken();
    const location = useLocation();

    if (!auth) {
      // Construct the redirect URL with the intended destination route and existing query parameters
      const redirectUrl = `/?redirect_to=${encodeURIComponent(location.pathname + location.search)}`;
      return <Navigate to={redirectUrl} />;
    }
    return children;
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/registerForm" element={<RegisterForm />} />
        <Route path="/registerForm/:affiliateIdParam" element={<RegisterForm />} />
        <Route path="/login-affiliate" element={<LoginAffiliateForm />} />
        <Route path="/register-affiliate" element={<AffiliateRegisterForm />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/partner/onboarding" element={<PartnerOnboardingBridge />} />
        <Route path="/externalAwsAuthResult" element={<ExternalAwsAuthResult />} />
        <Route path="/appApproval" element={<ProtectedRoute><AppApprovalForm /></ProtectedRoute>}/>
        <Route path="/enterAmazonUrl/:id" element={<ProtectedRoute><EnterAmazonUrl /></ProtectedRoute>}/>
        <Route
          path="/layout/*"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/affiliate-layout/*"
          element={
            <ProtectedRoute>
              <AffiliateLayout />
            </ProtectedRoute>
          }
        >
          <Route path="affiliate-monthly-breakdown" element={<AffiliateMonthlyBreakdown />} />
        </Route>
      </Routes>
    </>
  );
};
